<template>
  <v-card flat class="container--fluid">

    <v-card flat class="container--fluid bg-gray no-margins elevation-1 not-rounded">
      <v-card flat class="v-card__container">
        <v-card-title class="no-margins d-flex align-start">
          <h4 class="mb-2">Lärlingsanmälningar</h4>
          <v-spacer></v-spacer>
          <SimpleSearch v-show="simple" v-model="search" @search="doSearch" @switchMode="switchMode"/>
        </v-card-title>
        <AdvancedSearch v-show="!simple" v-model="advSearch" :allowSwitchMode="!isRegionary" :initalSearch="true" :searchFields="advancedSearchFields" @search="doSearch" @switchMode="switchMode" />
      </v-card>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="applications"
      :class="'clickable action-icon mx-6 mt-6'"
      :loading="isLoading"
      :sort-by="this.options.sortBy"
      :sort-desc="true"
      :options.sync="options"
      :server-items-length="totalRows"
      :items-per-page="itemsPerPage"
      :search="search"
      item-key="id"
      @click:row="showApplication"
    >
      <template slot="item.id" slot-scope="props">
        <div style="text-align: right; padding-right: 28px">{{ props.item.id }}</div>
      </template>
      <template slot="item.regionId" slot-scope="props">
        <div>{{ props.item.region ? props.item.region.name : '' }}</div>
      </template>
      <template slot="item.lastName" slot-scope="props">
        <div v-if="props.item && props.item.firstName && props.item.lastName">
          {{ props.item | fullName }}
        </div>
      </template>
      <template slot="item.personalNumber" slot-scope="props">
        <div v-if="props.item && props.item.personalNumber">
          {{ showPersonalnumber(props.item.personalNumber) }}
        </div>
      </template>
      <template slot="item.email" slot-scope="props">
        <div v-if="props.item.isProtected">
          {{
            props.item && props.item.email ? props.item.email : ''
          }}
        </div>
        <div v-else>
          <a class="emailcolumn" @click.stop :href="`mailto:${props.item.email}`">{{
            props.item && props.item.email ? props.item.email : ''
          }}</a>
        </div>
      </template>
      <template slot="item.state" slot-scope="props" class="ma-0 pa-0">
        <div
          class="d-flex"
          @click.stop="
            application = props.item
            showInfo = !showInfo
          "
        >
          {{ props.item && props.item.state && props.item.state.name ? props.item.state.name : '' }}
          <div>
            <v-icon class="ml-1">$sl-information-circle</v-icon>
          </div>
        </div>
      </template>

      <template slot="item.createdAt" slot-scope="props">
        <div v-if="props.item && props.item.createdAt">
          {{ props.item.createdAt | date }}
        </div>
      </template>
      <template slot="item.notes" slot-scope="props">
        <div style="width: 50px">
          <v-icon v-if="props.item.notes && props.item.notes.length">$sl-message</v-icon>
        </div>
      </template>
    </v-data-table>

    <v-btn absolute bottom right fab @click="addApplication()" :disabled="!canCreate">
      <v-icon class="ml-1">$sl-add</v-icon>
    </v-btn>
    <ApplicationInfoModal
      v-if="application"
      @close="showInfo = !showInfo"
      :showInfo="showInfo"
      :application="application"
    />
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {pageSize} from '@/store/constants'
import groupBy from 'lodash/groupBy'
import flatten from 'lodash/flatten'
import get from 'lodash/get'
import ApplicationStateCriteria from '@/components/application/ApplicationStateCriteria'
import ApplicationRegionCriteria from '@/components/application/ApplicationRegionCriteria'
import ApplicationInfoModal from '@/components/application/ApplicationInfoModal'
import DatePicker from '@/components/common/DatePicker'
import {Criterias, CanIDo} from '@/components/mixins'
import SimpleSearch from "@/components/search/Simple";
import AdvancedSearch from "@/components/search/Advanced";

// @group Application
// Applications component
export default {
  name: 'Applications',

  mixins: [Criterias, CanIDo],

  components: {
    DatePicker,
    ApplicationStateCriteria,
    ApplicationRegionCriteria,
    ApplicationInfoModal,
    SimpleSearch,
    AdvancedSearch
  },

  data: () => ({
    simple: false,
    search: '',
    showInfo: false,
    application: {},
    options: {},
    itemsPerPage: pageSize,
    totalRows: 0,
    applications: [],
    headers: [
      { text: "Nr.", value: "id", width: "70" },
      { text: "Namn", value: "lastName", width: "200" },
      { text: "Personnummer", value: "personalNumber", width: "150" },
      { text: "Mobiltelefon", value: "mobilephone", width: "150" },
      { text: "E-post", value: "email", width: "200" },
      { text: "Region", value: "regionId", width: "200" },
      { text: 'Ant.', value: 'notes', sortable: false, width: '65'},
      { text: "Status", value: "state", width: "200", sortable: false },
      { text: "Skapad", value: "createdAt", width: "130" },
    ],
    menu: false,
    menu2: false,
    advSearch: {
      stateId: []
    },
    originalFilterItems: {},

    //- For fragment criterias
    criteria: {},
    inited: false
  }),

  async created() {
    console.log('Applications - created')

    //- set default states
    const applicationStates = this.basicApplicationStates
    const initialStates = applicationStates.filter(s => s.state !== 'draft')
    const stateGroups = groupBy(initialStates, 'name')
    const initialStatesValues = Object.keys(stateGroups).map(o => {
      return stateGroups[o].map(g => {
        return g.id ? g.id : null
      })
    })

    if(this.isRegionary == true) {
      this.advSearch.regionId = get(this.currentUser, 'userRegions', []).map(region => region.regionId)
    }

    // @vuese
    //- Get criteria from url hash fragment
    const locationCriteria = this.getCriteriaFromLocation('c')
    // @vuese
    //- Set values if we have a criteria
    if (locationCriteria) {
      this.criteria = locationCriteria
      this.search = this.criteria.search
      this.advSearch = this.criteria.advSearch
      this.options = {
        page: this.criteria.page,
        itemsPerPage: this.criteria.pageSize,
        sortBy: [this.criteria.sortBy],
        sortDesc: [this.criteria.sortDesc]
      }
    }
    if (!this.advSearch.stateId || this.advSearch.stateId.length < 1) {
      this.advSearch.stateId = initialStatesValues
    }
    this.inited = true
  },

  watch: {
    options: {
      handler(data) {
        if (this.inited) {
          this.fetchListData()
        }
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('basic', ['basicApplicationStates', 'basicRegions', 'basicProfessions']),
    ...mapGetters('currentuser', ['currentPermissions', 'currentUser']),

    isRegionary() {
      return get(this.currentUser, "userrole.isRegionary", false)
    },

    advancedSearchFields() {
      return {
        applicationSearch: {
          heading: 'Fritext',
          chipLabel: 'Fritext',
          label: "Sök fritt efter anmälningar vars information innehåller:"
        },
        placeholder1: {
          heading: '',
          chipLabel: '',
          label: '',
          placeholder: true
        },
        firstName: {
          heading: 'Förnamn',
          chipLabel: 'Förnamn',
          label: "Sök efter personer vars förnamn innehåller:"
        },
        lastName: {
          heading: 'Efternamn',
          chipLabel: 'Efternamn',
          label: "Sök efter personer vars efternamn innehåller:",
        },
        regionId: {
          heading: 'Region',
          chipLabel: 'Region',
          label: "Välj regioner att söka bland:",
          items: this.basicRegions.reduce((acc, curr) => {
            if(this.isRegionary && !(this.currentUser.userRegions || []).map(r => r.regionId).includes(curr.id)){
              return acc
            }
            acc.push({value: curr.id, text: curr.name})
            return acc
          },[]),
          type: 'select',
          multiple: true
        },
        professionId: {
          heading: 'Yrke',
          chipLabel: 'Yrke',
          label: "Välj yrken att söka bland:",
          items: this.basicProfessions.map(o => {return {value: o.id, text: o.name}}),
          type: 'select',
          multiple: true
        },
        fromDate: {
          heading: 'Från datum',
          chipLabel: 'Från dat.',
          label: "Välj tidigaste datum då anmälan skapades",
          type: 'date',
        },
        toDate: {
          heading: 'Till datum',
          chipLabel: 'Till dat.',
          label: "Välj senaste datum då anmälan skapades",
          type: 'date',
        },
        stateId: {
          heading: 'Status',
          chipLabel: 'Status',
          label: "Välj status att söka bland:",
          items: this.groupedStates,
          type: 'select',
          multiple: true
        }
      }
    },

    groupedStates() {
      const allGroups = groupBy(this.basicApplicationStates,'state')
      return Object.keys(allGroups).map(o => {
            return {
              value: allGroups[o].map(g => {
                return g.id ? g.id : null
              }),
              text: allGroups[o][0]['name']
            }
          })
    }
  },

  asyncComputed: {
    canCreate(){
      return this.canIDo('application', 'create');
    },
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication']),

    switchMode() {
      this.simple=!this.simple
      if (this.simple) {
        this.advSearch = {}
      } else {
        this.search = ""
      }
      this.doSearch()
    },

    doSearch() {
      if (this.options.page > 1) {
        this.options.page = 1
      } else {
        this.fetchListData()
      }
    },

    /**
     * @vuese
     * Used to fetch application lists
     * @arg The arguments are the search criterias
     */
    fetchListData() {
      console.log('Applications - fetchApplications')

      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      const startAt = (page - 1) * this.itemsPerPage

      this.criteria = {
        page: page,
        startAt: startAt,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
        search: this.search,
        advSearch: {...this.advSearch, stateId: flatten(this.advSearch.stateId)},
        pageSize: this.itemsPerPage
      }

      const criteria = { ...this.criteria };
      if(this.isRegionary && (!criteria.advSearch.regionId || !criteria.advSearch.regionId.length)){
        criteria.advSearch['regionId'] = get(this.currentUser, 'userRegions', []).map(region => region.regionId)
      }

      API.listApplications(criteria)
        .then(response => {
          // @vuese
          //- Set fragment criteria
          this.criteria.advSearch = this.advSearch
          this.setCriteriaToLocation('c', this.criteria)
          this.applications = response.data.rows
          this.totalRows = response.data.count
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },

    async showApplication(item) {
      // clear previous one
      await this.setSelectedApplication(null)

      this.$nextTick(() => this.$router.push({name: 'Application', params: {id: item.id}}))
    },

    addApplication() {
      this.$router.push({name: 'ApplicationNew'})
    },
    /**
     *
     * Used to add mask to personal number
     */
    showPersonalnumber(personalNumber) {
      if (personalNumber && personalNumber.length > 7) return personalNumber.substring(0, 8) + '-****'
    }
  }
}
</script>

<style></style>
